import React, { useEffect, useState } from 'react';
import DataTable from '../../../../Components/Others/DataTable';
import { CancelButton, CreateButton, FilterButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import { Link, useLocation, useParams } from 'react-router-dom';
import SearchBar from '../../../../Components/Utils/SearchBar';
import UseGetData from '../../../../Components/Hooks/useFetchData';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import MoreOptions from '../../../../Components/Utils/MoreOptions';
import CustomDataTable from '../../../../Components/Others/CustomDataTable';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import { useFormik } from 'formik';
import * as yup from 'yup';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import { NuDate } from '../../../../Components/Utils/Input';
import Importdoc from './Importdoc';
import MultiEditRFQ from './MultiEditRFQ';
import ModalContainer from '../../../../Components/Others/ModalContainer';
import { GetAccess } from '../../../../Components/Utils/roles';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import ProcurementLayout from '../ProcurementLayout';
import { useNumber } from '../../../../Context/ProjectIdContext';
import MobileRFQ from '../../../Mobile/Procurement/RFQ/MobileRFQ';

function RFQIndex() {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const {officeId} =useParams();
  const {number} = useNumber()

  const location = useLocation();
  const currentPage= location.state?.currentPage
  const searchQuery= location.state?.searchQuery
  const [page, setPage] = useState(currentPage||1)
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
   const [filter, setFilter] = useState(false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const {value:Status} = useFetchMDIndex(`/dropdown/dropdown-details/`,'status_RFQ',showFilterDialog)

  const [filterProps, setFilterProps] = useState({
    status:"",
    fromDate:"",
    toDate:"",
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search:searchQuery||"",

    status:"",
    fromDate:"",
    toDate:"",

  });

  const clearFilter = ()=> {
    setParams({...params,status:"", fromDate:"",
    toDate:"",})
    formik.values.status=""
    formik.values.fromDate=""
    formik.values.toDate=""

      setFilter(false)
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff",value);
      setParams({...params,status:value.status,fromDate:value.fromDate,toDate:value.toDate})
      closeFilterDialog();
      setFilter(true)
      setFilterProps({
        status: "",
        fromDate:"",
        toDate:"",
      });
    }
  })
  const { data, totalCount, getData,dataLoading } = UseGetDataSearch( `/rfq/${number}/project`,params);

  const defaultHeader = [
   
    {
      title: "PR",
      width: "10%",
      isLink: true,
      id: "id",
      link: `/main/${officeId}/procurement/rfq/view/`,
      field: "prRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "RFQ Type",
      width: "10%",
      isLink: true,
      id: "id",
      link: `/main/${officeId}/procurement/rfq/view/`,
      field: "rfqType",
      textAlign: "center",
      rowAlign: "center",
    },
   
    
    {
      title: "Sup.",
      title2: "Local Purch.",
      mult:true,
      width: "10%",
      field: "vendorNameOrPurchaserName",
      textAlign: "center",
      rowAlign: "center",
    },
   
   
    {
      title: "Prepared By",
      width: "10%",
      field: "preparedByName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status",
      width: "10%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents:{
        // fetcher:getData,
        id:"id",
        removeValue:"ref",
        url:`/rfq/`,
        moduleName:"RFQ",
        from:`/main/${officeId}/procurement/rfq`,
        editLink:`/main/${officeId}/procurement/rfq/edit/`,
        viewLink:`/main/${officeId}/procurement/rfq/view/`,
        EmailRequired: true,
        emailType: false,
        adminPermmision: true
      }
    },
  ];
  const availableHeaders = [
   
    {
      title: "PR",
      width: "10%",
      isLink: true,
      id: "id",
      link: `/main/${officeId}/procurement/rfq/view/`,
      field: "prRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "RFQ Type",
      width: "10%",
      isLink: true,
      id: "id",
      link: `/main/${officeId}/procurement/rfq/view/`,
      field: "rfqType",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Supplier",
      width: "10%",
      field: "vendorName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Local Purchaser",
      width: "10%",
      field: "purchaserName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Prepared By",
      width: "10%",
      field: "preparedByName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status",
      width: "10%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Customer Reference",
      width: "10%",
      field: "customerRfq",
      textAlign: "center",
      rowAlign: "center",
    },
     
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents:{
        // fetcher:getData,
        id:"id",
        removeValue:"ref",
        url:`/rfq/`,
        moduleName:"RFQ",
        from:`/main/${officeId}/procurement/rfq`,
        editLink:`/main/${officeId}/procurement/rfq/edit/`,
        viewLink:`/main/${officeId}/procurement/rfq/view/`,
        EmailRequired: true,
        emailType: false
      }
    },
  ];
  useEffect(()=>{
    setParams({...params,page:page,per_page:pageCount})
   },[page,pageCount])

   const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };

  const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };

  const [showEdit, setShowEdit] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [listofNumbers, setListofNumbers] = useState([])
  const [fullList, setFullList] = useState([])

  const selectOneFunction = (value) =>{ 
    let NewId;
    if(listofNumbers && listofNumbers.some(Item=>Item ===value)){
      NewId = listofNumbers.filter(Temp=> Temp !== value);
      setListofNumbers(NewId)
    }else{
      setListofNumbers([...listofNumbers,value])
    }
  }

  const selectMultipleFunction = (e) =>{ 
console.log(e.target.checked);
if(e.target.checked){
  setListofNumbers(fullList)
}else{
  setListofNumbers([])
}

  }



  useEffect(()=>{
    let tempArr = []
    data && data.forEach(i=>{
      console.log("I",i?.id);
      tempArr.push(i?.id)
    });
    setFullList(tempArr)
  },[data])

 const [valueOfSearch,setValuesofSearch] = useState("")
   function searchFunction(e) {
 
     
     setValuesofSearch(e?.target?.value)
     setParams({ ...params, search: e?.target?.value, page:1 });
     setPage(1)
   }
 

  return (
    <>
    <ProcurementLayout 
     setOpen={closeModal}
     searchFun={searchFunction}
      searchValue={valueOfSearch}
     getData={getData}
     isFilter={filter}
     newfilter={true}
     neededSearch={true}

     setFilterOpen={setShowFilterDialog}
     ClearFilter={clearFilter}
     CreateAccess={GetAccess("rfq_create")}
    //  ImportAccess={GetAccess("rfq_create")}
     officeId={officeId}
    //  projectId={projectId}
       >
        {
  screenSize.width <= "786" ?(<>
  <div className=' w-full h-[calc(100vh-160px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
  <MobileRFQ
  data={data}
  total={totalCount}
  pageIndex={page}
  setPageIndex={setPage}
  dataCount={pageCount}
  setDataCount={setPageCount}
  officeId={officeId}
  getData={getData}

  />
  </div>
  </>):(<>
    <div className='w-full h-[calc(100vh-110px)]  '>
     

      <CustomDataTable 
      fetcher={getData}
        data={data} 
        availableHeaders={availableHeaders} 
        defaultHeader={defaultHeader}
        bodyHeight="max-h-[calc(100vh-260px)]"
        height="h-[calc(100vh-145px)]"
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        // title='RFQ List'
        storageName="RfqTable"
        selectOneFunction={selectOneFunction}
        setShowDelete={setShowDelete}
        showDelete={showDelete}
        setShowEdit={setShowEdit}
        showEdit={showEdit}
        listofNumbers={listofNumbers}
        hasMultiEdit={true}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        getById="id"
        editAccess="rfq_edit"      
        deteleAccess="rfq_delete" 
        // EmailRequired={true}
        dataLoading={dataLoading}
        searchQuery={params?.search!=""?params?.search:""}

        />
        </div>
        </>)
        }
        </ProcurementLayout>
          {showFilterDialog && (
             
             
             <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
               <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
                 <h2 className="text-xl mb-4">Filter RFQ</h2>
                 <form onSubmit={formik.handleSubmit}> 
                    <div className="flex flex-col mb-4">
                    <p className="py-2 px-6 text-m">Date</p>
                    <div className="flex justify-between  w-full ">
             <NuDate
              label="From "
              placeholder="dd/mm/yyyy"
              formik={formik}
              name="fromDate"
              width="w-full "
            />
           <NuDate
              label="To "
              placeholder="dd/mm/yyyy"
              formik={formik}
              name="toDate"
              width="w-full "
            />
            </div>
            <FormikSelectTwo
            type="text"
            label="Status"
            placeholder="Status"
            Options={Status}
           formik={formik}
           name="status"
           width="w-full"
          />
                     
                    </div>
                   <div className="flex justify-end gap-2">
                     <CancelButton handleClick={closeFilterDialog} />
                     <SubmitButton name='Apply' />
                   </div>
                  </form> 
               </div>
             </div>
           )}
        {showImportModal && (<Importdoc show={showImportModal} onClose={closeModal} getData={getData} />)}
        {showEdit && (<MultiEditRFQ data={listofNumbers} getData={getData} onClose={()=>setShowEdit(false)}/>)}
        <ModalContainer
                visiable={showDelete}
                title="Warning"
                content={`Are you sure, All selected datas will be removed from PR List!`}
                handleClick={() =>{}}
                closeModal={() => setShowDelete(false)}
            />
    </>
  )
}

export default RFQIndex